const getCacheBustingQuery = (hours = 1) => {
  const hoursSinceEpoch = Math.floor(Date.now() / (1000 * 60 * 60));
  const version = Math.floor(hoursSinceEpoch / hours);
  return `v=${version}`;
};
export default getCacheBustingQuery;
